/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { Button, TextField, CircularProgress } from "@material-ui/core";

import { LOADING_STATE, PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  bookInput: {
    marginBottom: 10,
  },
  bookButton: {
    padding: "15px 30px",
    width: "100%",
  },
};

const signupNewsletter = async (email, setSendState) => {
  setSendState(LOADING_STATE.LOADING);
  const response = await fetch("/api/Contact/SignupNewsletter", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(email),
  });
  if (response.ok) {
    setSendState(LOADING_STATE.LOADED);
  }
  else {
    setSendState(LOADING_STATE.ERROR);
  }
};


const EBook = () => {

  const [email, setEmail] = React.useState("");
  const [sendState, setSendState] = React.useState(LOADING_STATE.NOT_LOADING);

  let submitLabel = "Sign up";
  if (sendState === LOADING_STATE.LOADING) {
    submitLabel = <CircularProgress size={25} />;
  }
  else if (sendState === LOADING_STATE.LOADED) {
    submitLabel = "Received! Check your inbox";
  }
  else if (sendState === LOADING_STATE.ERROR) {
    submitLabel = "Retry";
  }

  React.useEffect(() => {
    //Start curator widget
    const script = document.createElement("script");
    script.src = "https://cdn.curator.io/published/43631de1-a42b-40f2-b30e-cafb92328f47.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.EBOOK]}
        path={PAGE_ROUTES.EBOOK}
      />

      <section className={"ebook-book-section standard-width"}>
        <div className={"home-book-outer"}>
          <div className={"home-book-inner"}>
            <div className={"home-book-content"}>
              <h2>Download our free e-book</h2>
              <p>
                Sign up to our newsletter to receive a free copy of our e-book
                "A registered dietitian's top 5 low calorie, high protein recipes".
              </p>
              <TextField
                label={"Email"}
                variant={"outlined"}
                type={"email"}
                style={styles.bookInput}
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                variant={"contained"}
                color={"primary"}
                style={styles.bookButton}
                onClick={() => signupNewsletter(email, setSendState)}
                disabled={(sendState === LOADING_STATE.LOADING) || (sendState === LOADING_STATE.LOADED)}
              >
                {submitLabel}
              </Button>
            </div>
            <img
              className={"home-book-img"}
              src={"/images/home/book.webp"}
              alt={"Top 5 low calorie high protein recipes e-book"}
            />
          </div>
        </div>
      </section>

      <section className={"home-instagram-section"}>
        <h2 className={"section-head"}>Get Social With Us</h2>
        <div id={"curator-feed-ash-layout"}>
          <a
            href={"https://curator.io"}
            target={"_blank"}
            className={"crt-logo crt-tag"}
            rel={"noreferrer"}
          >
            Powered by Curator.io
          </a>
        </div>
      </section>
    </main>
  );
};

export default EBook;
